module.exports = __webpack_public_path__ + "static/media/gallery_2_4.eb1e77ee.jpg";